export default __webpack_public_path__ + "static/media/na_es.9fb62d35.png";